import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";
import App from "./App";
import store from "./config/store";
import { BrowserRouter as Router } from "react-router-dom";
import Loading from "./components/loading/Loading";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Suspense fallback={<Loading />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </Router>,
);
